// Lazy accessor for the camera database (~1 MB) so it stays out of the main
// bundle. CalculatorContext needs it synchronously during its very first
// render to seed dailies state WITHOUT a hydration mismatch, so index.js
// preloads it (for routes that render camera data) before hydrateRoot and
// this module caches the loaded namespace for synchronous access.
let cameraDataModule = null;

export const loadCameraData = () =>
  import('./cameraData').then((mod) => {
    cameraDataModule = mod;
    return mod;
  });

// Returns the module if it has been loaded, else null. Callers must handle
// null (e.g. seed empty lists and populate on mount).
export const getCameraDataSync = () => cameraDataModule;
